import {
  AfterViewInit,
  ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild,
} from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatAutocompleteTrigger } from '@angular/material'
import { map, startWith, takeUntil } from 'rxjs/operators'

import { AutocompleteSection } from './autocomplete-section'
import { AutocompleteItem } from './autocomplete-item'
import { CommonComponent } from '../common.component'

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteComponent extends CommonComponent implements AfterViewInit {

  @ViewChild('input') input: ElementRef
  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger
  itemCtrl = new FormControl()
  filteredItems = []
  sectionsVal: AutocompleteSection[]
  @Input() autodeselect: boolean
  @Input() placeholder: string
  @Input() hideInactive: boolean
  @Output() onSelectedItem = new EventEmitter<AutocompleteItem>()

  constructor() {
    super()
  }

  @Input() set open(val: boolean) {
    setTimeout(() => {
      if (val) {
        this.trigger.openPanel()
      } else {
        this.trigger.closePanel()
      }
    }, 0)
  }

  @Input() set sections(val: AutocompleteSection[]) {
    this.sectionsVal = val
    if (this.sectionsVal) {
      this.filteredItems = []
      this.sectionsVal.forEach((section: AutocompleteSection) => {
        this.filteredItems.push(this.itemCtrl.valueChanges.pipe(
          startWith(null),
          map(a => this.filterItems(section.items, a)))
        )
      })
    }
  }

  @Input() set disabled(val: boolean) {
    if (val) {
      this.itemCtrl.disable()
    } else {
      this.itemCtrl.enable()
    }
  }

  filterItems(arrayToFilter: AutocompleteItem[], item: AutocompleteItem | string) {
    let arr: any[]
    if (item) {
      // tests for the name string to contain val at the beginning of the word
      arr = arrayToFilter
        .filter(s => this.hideInactive ? s.isActive : true)
        .filter(s => {
        const filter = typeof item === 'string' ? item : item.name
        return new RegExp(`\\b${filter}`, 'gi').test(s.name)
      })
    } else {
      arr = arrayToFilter.filter(s => this.hideInactive ? s.isActive : true)
    }
    return arr
  }

  displayFn(item: AutocompleteItem) {
    return item ? item.name : ''
  }

  ngAfterViewInit() {
    this.input.nativeElement.focus()

    this.trigger.autocomplete.optionSelected.pipe(
      map(event => event.option),
      takeUntil(this.ngUnsubscribe))
      .subscribe(option => {
        this.onSelectedItem.emit(option.value)
        if (this.autodeselect) {
          option.deselect()
          this.itemCtrl.setValue('')
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/autocomplete/autocomplete.component.ts